import * as React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { epochToFormattedDate, getUserId } from "../../helper/helper";
import { getMethod, putMethod } from "../../services/apiService";
import { AntSwitch } from "../licenses/licencesTabs/LicenseTabTwo";
import { useLocation } from "react-router-dom";
import InfoHoverTooltip from "../Tooltips/InfoHover";

function createData(
id: any, name: any, issueDate: any, expiryDate: any, validity: any, orderID: any, status: any, quantity: any, total: any, available: any,assigned:any, expiryTimestamp: any,featureKey: any ): any {
  return {
    id,
    name,
    issueDate,
    expiryDate,
    validity,
    orderID,
    status,
    quantity,
    total,
    available,
    assigned,
    expiryTimestamp,
    featureKey
  };
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const tableCellStyle = { borderBottom: "1px solid #5A5F60", color: "#B4B7B8", fontSize: "14px !important" };

function EnhancedTableHead(props: any) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    header,
  } = props;
  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead sx={{ borderBottom: "2px solid #313838" }}>
      <TableRow>
        <TableCell
          padding="checkbox"
          sx={{ borderBottom: "1px solid #5A5F60" }}
        >
          {/* <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}

          /> */}
        </TableCell>
        {header?.map((headCell: any) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              color: "white",
              borderBottom: "1px solid #5A5F60",
              textAlign: headCell?.label === "Status" || headCell?.label === "Quantity" ? "center" : "",
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              hideSortIcon
              sx={{ color: "white !important" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function SortTable({
  header,
  rowData = [],
  activeTab,
  getPartnerName,
  getTableData,
  selected,
  setSelected,
  setResetLicenseOvervie,
}: any) {
  const [order, setOrder] = React.useState<any>("asc");
  const [orderBy, setOrderBy] = React.useState<any>("issueDate");
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [tableRowData, setTableRowData] = React.useState<any>([]);
  const [licenseData, setLicenseData] = React.useState<any>([]);
  const [licenseDetails, setLicenseDetails] = React.useState<any>(null);

  React.useEffect(() => {
    const isData = Array.isArray(rowData?.[0]?.data) ? rowData[0].data : [];
    const orderId = rowData?.[0]?.orderId;
    const orderName= rowData?.[0]?.orderName;
    const manipulationData = isData?.map((i: any, index: any) =>
      createData(
        index,
        getPartnerName(i?.licenseKey),
        epochToFormattedDate(i?.createdAt),
        epochToFormattedDate(i?.expiry),
        i?.validity,
        // orderId,
        orderName,
        i?.status,
        i?.quantity,
        i?.total,
        i?.available,
        i?.assigned,
i?.expiry,
i?.featureKey
      )
    );

    const visibleRows = [...manipulationData]
      .sort(getComparator(order, orderBy))
      //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    setTableRowData(visibleRows);
  }, [order, orderBy, page, rowsPerPage, activeTab, rowData]);



  React.useEffect(() => {
    console.log("------------------------------------------------");
    console.log(tableRowData);
  }, [tableRowData])


  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = tableRowData?.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleToggleChange = async (row: any, index: any) => {
    const isData = Array.isArray(rowData?.[0]?.data) ? rowData[0].data : [];

    try {
      const payload = {
        orderId: rowData?.[0]?.orderId,
        orderRef: rowData?.[0]?.orderRef,
        data: [
          {
            featureKey: row?.featureKey,
            status: row?.status ? 0 : 1,
            expiry: row?.expiryTimestamp,
          },
        ],
      };

      const response = await putMethod("customer/order", payload).then(
        (res) => {
          if (res?.status === 200) {
            setResetLicenseOvervie(true);
            getTableData();
            return res;
          }
        }
      );
      setLicenseDetails(response?.data.result);
    } catch (error) {
      console.error("Error enabling the license:", error);
    }
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableRowData.length) : 0;

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          width: "100%",
          mb: 2,
          background: "transparent",
          border: "1px solid #313838",
          borderRadius: "10px",
        }}
      >
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={tableRowData.length}
              header={header}
            />
            <TableBody>
              {tableRowData?.map((row: any, index: any) => {
                const isItemSelected = selected.includes(row?.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event) => handleClick(event, row?.id)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id}
                    selected={isItemSelected}
                    sx={{ cursor: "pointer", border: "1px solid #5A5F60" }}
                  >
                    <TableCell padding="checkbox" sx={tableCellStyle}>
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" id={labelId} scope="row" padding="none" sx={tableCellStyle}>{row.name}</TableCell>
                    <TableCell align="left" sx={tableCellStyle}>{row?.issueDate}</TableCell>
                    <TableCell align="left" sx={tableCellStyle}>{row?.expiryDate}</TableCell>
                    <TableCell align="left" sx={tableCellStyle}>
                    {(row?.validity === 1 || row?.validity === 3 || row?.validity === 5) ? `${row?.validity} Year${row?.validity > 1 ? 's' : ''}` : (
                        row?.validity === 30 ? "30 Days" : (
                          row?.validity === 365 ? "1 Year" : (
                            row?.validity / 365 + " Years")
                        )
                      )}
                    </TableCell>
                    <TableCell align="left" sx={tableCellStyle}>{row?.orderID}</TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        ...tableCellStyle,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleChange(row, index);
                      }}
                    >
                      {/* {row?.status} */}
                      <AntSwitch
                        disabled={row?.status !== 0}
                        checked={row?.status}
                        inputProps={{ "aria-label": "ant design" }}
                      />
                      <Typography
                        sx={{ display: "inline", marginLeft: "10px" }}
                      >
                        {row?.status ? "Enabled" : "Disabled"}
                      </Typography>
                    </TableCell>
                    <TableCell align="center" sx={tableCellStyle}>


                    <InfoHoverTooltip title={"Used / Total"}
													arrowDirection="top">
													<Typography component="span">
                          {row?.assigned}/{row?.total}
													</Typography>
												</InfoHoverTooltip>



                    </TableCell>
                  </TableRow>
                );
              })}
              {tableRowData?.length === 0 ? (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={8} style={{color:'#B4B7B8',textAlign:'center'}}>No data found!</TableCell>
                </TableRow>
              ) : (
                ""
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
